import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import logo from "../../common/images/logo.png";

import NavBarIcon1 from "../../common/images/NavBarIcon1.png";
import NavBarIcon2 from "../../common/images/NavBarIcon2.png";
import NavBarIcon3 from "../../common/images/NavBarIcon3.png";
import NavBarIcon4 from "../../common/images/NavBarIcon4.png";
import NavBarIcon5 from "../../common/images/NavBarIcon5.png";
import SettingIcons from "../../common/images/SettingIcons.png";

import NavBarIconA1 from "../../common/images/NavBarIconA1.png";
import NavBarIconA2 from "../../common/images/NavBarIconA2.png";
import NavBarIconA3 from "../../common/images/NavBarIconA3.png";
import NavBarIconA4 from "../../common/images/NavBarIconA4.png";
import NavBarIconA5 from "../../common/images/NavBarIconA5.png";
import SettingIconsA from "../../common/images/SettingIconsA.png";

import userPrfImg from "../../common/images/userPrfImg-rmbg.png";

import { UserProfileModal } from "./UserProfileModal";
import { ChangePasswordModal } from "./ChangePasswordModal";

const Sidebar = () => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showChangePasswrd, setShowChangePasswrd] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { userInfo, logout } = useAuth();
  console.log('userInfo', userInfo);

  const role = localStorage.getItem("roleKey");

  /*useEffect(() => {
    if (window.devicePixelRatio > 1) {
      document.body.style.zoom = 1 / window.devicePixelRatio;
    }
  }, []);*/

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    setIsProfileMenuOpen(false);
    logout();
  };

  const handleProfile = () => {
    setIsProfileMenuOpen(false);
    setShowProfile(true);
  };

  const handleChangePassword = () => {
    setIsProfileMenuOpen(false);
    setShowChangePasswrd(true);
};

const handleChangePasswordCancel = () => {
      setShowChangePasswrd(false);
}

  const handleProfileClose = () => {
    setShowProfile(false);
  };

  return (
    <div className="sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <img src={logo} alt="logo" />
      </div>

      {/* Menu */}
      <ul className="sidebar-menu">
        <li className="menu-item">
          <NavLink to="/" className="sidebar-icon">
            <img src={NavBarIcon1} alt="DS" className='menuicon-img' />
            <img src={NavBarIconA1} alt='DS' className='menuicon-active-img' />
          </NavLink>
          <ul className="submenu">
            <li><NavLink to="/">Dashboard</NavLink></li>
          </ul>
        </li>
        {(role === 'super_admin') && <li className="menu-item">
          <NavLink to="/bunk" className="sidebar-icon">
            <img src={NavBarIcon2} alt="BK" className='menuicon-img' />
            <img src={NavBarIconA2} alt='BK' className='menuicon-active-img' />
          </NavLink>
          <ul className="submenu">
            <li><NavLink to="/bunk">Petrol Bunk Management</NavLink></li>
          </ul>
        </li>}
        <li className="menu-item">
          <NavLink to={(role === 'bunk_incharge')?"/bunkdetail":"/camera"} className="sidebar-icon">
            <img src={NavBarIcon3} alt="CR" className='menuicon-img' />
            <img src={NavBarIconA3} alt='CR' className='menuicon-active-img' />
          </NavLink>
          <ul className="submenu">
            <li><NavLink to={(role === 'bunk_incharge')?"/bunkdetail":"/camera"}>Camera Management</NavLink></li>
          </ul>
        </li>
        <li className="menu-item">
          <NavLink to="/users" className="sidebar-icon">
            <img src={NavBarIcon4} alt="UR" className='menuicon-img' />
            <img src={NavBarIconA4} alt='UR' className='menuicon-active-img' />
          </NavLink>
          <ul className="submenu">
            <li><NavLink to="/users">{(role === 'super_admin')?"User Management":"Employee Management"}</NavLink></li>
          </ul>
        </li>
        <li className="menu-item">
          <NavLink to="/vehicle" className="sidebar-icon">
            <img src={NavBarIcon5} alt="VC" className='menuicon-img' />
            <img src={NavBarIconA5} alt='VC' className='menuicon-active-img' />
          </NavLink>
          <ul className="submenu">
            <li><NavLink to="/vehicle">Vehicle Management</NavLink></li>
          </ul>
        </li>
      </ul>

      {/* Bottom */}
      <div className="sidebar-bottom" ref={menuRef}>
        {/*<div className="sidebar-icon">
          <img src={SettingIcons} alt="profile" />
        </div>*/}
        <div className="menu-item">
            <NavLink to="/fuelrate" className="sidebar-icon">
            <img src={SettingIcons} alt="ST" className='menuicon-img' />
            <img src={SettingIconsA} alt='ST' className='menuicon-active-img' />
          </NavLink>
          <ul className="submenu">
            <li><NavLink to="/fuelrate">Fuel Rate Management</NavLink></li>
          </ul>
        </div>
        
        <div className="sidebar-avatar" onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}>
          <img src={(userInfo?.profileImage)?userInfo?.profileImage:userPrfImg} alt="profile" />
        </div>

        {/* Profile Dropdown Menu */}
        {isProfileMenuOpen && (
          <div className="profile-dropdown-menu">
            <div className="profile-menu-item" onClick={handleProfile}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>Profile</span>
            </div>
            <div className="profile-menu-item" onClick={handleChangePassword}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <span>Change Password</span>
            </div>
            <div className="profile-menu-divider"></div>
            <div className="profile-menu-item logout" onClick={handleLogout}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span>Logout</span>
            </div>
          </div>
        )}  

      </div>
      {/* Bottom menu - end */}

      {(userInfo) && <>  
      <ChangePasswordModal
        show={showChangePasswrd}
        onHide={handleChangePasswordCancel}
      />

      <UserProfileModal
          show={showProfile}
          onHide={handleProfileClose}
          resultdata={userInfo}
        />
       </>
      } 

    </div>
  );
};

export default Sidebar;
